import * as React from 'react';
import GoogleMapReact from 'google-map-react';
import './AboutPage.css';
import { googleCloudConfig } from '../google/config';

const images: { [name: string]: any } = {
    Christopher: require(`../images/team/outdr_chris.jpg`),
    Tom: require(`../images/team/outdr_tom.jpg`),
    Julia: require(`../images/team/outdr_julia.jpg`),
    Dillinger: require(`../images/team/outdr_dillinger.jpg`),
    Otto: require(`../images/team/outdr_otto.png`),
    Logo: require(`../images/outdr_logo_mark.png`),
};

export const getMapsUrl = ({ lat, lng }: { lat: number; lng: number }) => `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

const AboutLocation = (location: { lat: number; lng: number }) => {
    return (
        <div className="aboutLocation flex-row">
            <div className="aboutLocationDot" />
            <a href={getMapsUrl(location)}>
                <address>
                    Outdr Ltd<br />
                    86-90 Paul Street<br />
                    London, UK
                </address>
            </a>
        </div>
    );
};

const AboutPage = () => {
    return (
        <div className="pageBody aboutBody">
            <section>
                <img alt={`Outdr logo`} className="aboutMissionImg" src={images.Logo} />
                <h2>Our mission</h2>
                <p>
                    To get more people outdoors and connected to their environment, and create an inclusive ecosystem in which all sides are considered.
                </p>
            </section>
            <section>
                <h2>Who we are</h2>
                <p>
                    Outdr was founded by a couple of enthusiastic amateurs who love the outdoors.
                </p>
                <div className="aboutTeamRow">
                    <AboutTeamMember name={'Christopher'} title={'Founder'} />
                    <AboutTeamMember name={'Tom'} title={'Founder'} />
                    <AboutTeamMember name={'Julia'} title={'Design Adviser'} />
                    <AboutTeamMember name={'Dillinger'} title={'Adventure Dog'} />
                    <AboutTeamMember name={'Otto'} title={'Brand Ambassador'} />
                </div>
            </section>
            <section>
                <h2>Where we work</h2>
                <p>
                    {`Our offices are located in Old Street, the heart of London's vibrant tech hub.`}
                </p>
                <div className="aboutMap">
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: googleCloudConfig.mapsApiKey }}
                        center={{ lat: 51.5256394, lng: -0.085802 }}
                        zoom={13}
                    >
                        <AboutLocation lat={51.525663} lng={-0.083745} />
                    </GoogleMapReact>
                </div>
            </section>
        </div>
    );
};

const AboutTeamMember = ({ name, title }: { name: string; title: string }) => {
    return (
        <div className="aboutTeamMemberCard small-card flex-col">
            <img className="aboutTeamMemberPhoto" src={images[name]} alt={name} />
            <div className="flex-row flex-between flex-wrap">
                <div><b>{name}</b></div>
                <div>{title}</div>
            </div>
        </div>
    );
};

export default AboutPage;